<template>
  <form
    :class="{ initializing: !initialized, loading }"
    @submit.prevent="submit"
  >
    <loader v-if="loading" :loading="loading"></loader>
    <div class="form-section columned two-column unlined">
      <div
        class="form-group vanilla no-divider"
        :class="{ 'has-input-error': errors.full_name }"
      >
        <label for="byron-name">
          Full Name
          <span class="required">*</span>
        </label>
        <input
          id="byron-name"
          type="text"
          required
          v-model="byron.full_name"
          @keydown="delete errors.full_name"
        />
        <input-error v-if="errors.full_name">{{
          errors.full_name[0]
        }}</input-error>
      </div>
      <div
        class="form-group vanilla no-divider"
        :class="{ 'has-input-error': errors.email }"
      >
        <label for="byron-email">
          Email
          <span class="required">*</span>
        </label>
        <input
          id="byron-email"
          type="email"
          required
          v-model="byron.email"
          @keydown="delete errors.email"
        />
        <input-error v-if="errors.email">{{ errors.email[0] }}</input-error>
      </div>
      <div
        class="form-group vanilla no-divider"
        :class="{ 'has-input-error': errors.location }"
      >
        <label for="byron-mobile">
          Mobile No.
          <span class="required">*</span>
        </label>
        <input
          id="byron-mobile"
          type="number"
          required
          v-model="byron.mobile"
          @keydown="delete errors.mobile"
        />
        <input-error v-if="errors.mobile">{{ errors.mobile[0] }}</input-error>
      </div>
    </div>
    <div
      class="form-group vanilla no-divider"
      :class="{ 'has-input-error': errors.description }"
    >
      <label for="byron-desc">
        Description
        <span class="required">*</span>
      </label>
      <textarea
        id="byron-desc"
        required
        v-model="byron.description"
        @keydown="delete errors.description"
      />
      <input-error v-if="errors.description">{{
        errors.description[0]
      }}</input-error>
    </div>
    <button type="submit" class="button tertiary mt-6">Submit</button>
  </form>
</template>

<script>
import BaseModal from "../Base";

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  mounted() {},
  data() {
    return {
      initialized: false,
      loading: false,
      byron: {
        full_name: null,
        email: null,
        mobile: null,
        description: null,
      },
      errors: {},
    };
  },
  methods: {
    submit() {
      this.loading = true;
      this.errors = {};
      axios
        .post("/api/byron/enquire", this.byron)
        .then((response) => {
          this.confirmAction();
          const data = response.data;
          this.$store
            .dispatch("modals/show", {
              title: "Byron Enquire.",
              type: "byron-enquire-confirm",
              narrow: true,
              data,
            })
            .then(() => {})
            .catch(() => {});
        })
        .catch((error) => {
          this.errors = error.response.data.errors || {};
          if (error.response.status === 422) {
            this.$toasted.show(
              `Your ${this.data.type} was unable to be submitted, please review errors and try again`,
              {
                type: "error",
              }
            );
            return this.openSectionWithErrors();
          }

          this.$toasted.show(
            "An error has occurred, please reload the page and try again",
            {
              type: "error",
            }
          );
        })
        .then(() => {
          this.loading = false;
        });
    },

    showLogin() {
      this.$store.commit("user/changeAuthMode", {
        which: "login",
        priority: true,
      });
    },
  },

  watch: {
    authed(now) {
      // if (this.$store.getters['user/isLister']) {
      //   return this.cancelAction()
      // }

      if (now) {
        if (this.activeSection === "contact-details") {
          this.fetchEstimate();
        }
        this.$store.commit("account/hide", true);
      }
    },
  },

  created() {},
};
</script>
